module.exports = __webpack_public_path__ + "img/zone-green.c315b7e1.png";